const subheadingData = {
    1: [
        {
            title: "About Me",
            content: (
                <>
                  <p>
                    Hello World! <br/> I'm Mateo Paez, a developer based out of Edmonton. I have experience developing and using Full-Stack web technologies & mobile applications,
                    programming video games in different engines, as well as Front-End & game level design.
                  </p>
                </>
            ),
        },
    ],
    
    2: [
        {
            title: "2024 Bachelors Degree",
            content: (
                <>
                  <p>
                   Graduated from the University of Alberta with a B.Sc. Computer Science with Specialization degree.
                  </p>
                </>
            ),
        },
    ],

    3: [
        {
            title: "2022 Code Ninjas",
            content: (
                <>
                  <p>
                   Taught children and teenagers fundamental programming practices via a programming curriculum which utilizes JavaScript, Lua, 
                   C#, Makecode Arcade, and Unity. <br/> In the summer months I ran daily and weekly STEM camps specializing in Lua and how to create 
                   complex environments in Roblox Studio.
                  </p>
                </>
            ),
        },
    ],
};

export default subheadingData;
